import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Download from '@mui/icons-material/Download';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import { useTheme } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import announcement1 from './images/announcement-2.webp';
import submit from './images/announcement-3.webp';
import announcement3 from './images/Final Annoucement.webp';

const mock = [
    {
        media: announcement1,
        // subtitle: 'Abstract Submission . . .',
        url: '/announcement',
        isDownload: false,
    },
    {
        media: submit,
        // subtitle: 'Registration Fee . . .',
        url: '/news',
        isDownload: false,
    },
    {
        media: announcement3,
        subtitle: 'Final Announcement',
        url: '/assets/Final Announcement The 6th InaACC 2024.pdf',
        isDownload: true,
    },
];

const QuickAccess = () => {
    const theme = useTheme();

    return (
        <Box>
            <Box marginBottom={4}>
                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: 'bold',
                    }}
                    gutterBottom
                    align={'center'}
                >
                    News & Articles
                </Typography>
            </Box>
            <Grid container spacing={4}>
                {mock.map((item, i) => (
                    <Grid
                        item
                        xs={12}
                        md={4}
                        key={i}
                        data-aos={'fade-up'}
                        data-aos-delay={i * 100}
                        data-aos-offset={100}
                        data-aos-duration={600}
                    >
                        <Box
                            display={'block'}
                            width={1}
                            height={1}
                            sx={{
                                transition: 'all .2s ease-in-out',
                                '&:hover': {
                                    transform: `translateY(-${theme.spacing(
                                        1 / 2,
                                    )})`,
                                },
                            }}
                        >
                            <Box
                                component={Card}
                                width={1}
                                height={1}
                                display={'flex'}
                                flexDirection={'column'}
                                sx={{ backgroundImage: 'none' }}
                            >
                                <Box
                                    component={CardMedia}
                                    borderRadius={2}
                                    width={1}
                                    height={1}
                                    minHeight={320}
                                    image={item.media}
                                />
                                <CardContent>
                                    <Typography
                                        variant={'h6'}
                                        gutterBottom
                                        sx={{ fontWeight: 700 }}
                                        align={'center'}
                                    >
                                        {item.title}
                                    </Typography>
                                    <Typography
                                        align={'center'}
                                        variant={'subtitle2'}
                                        color="text.secondary"
                                    >
                                        {item.subtitle}
                                    </Typography>
                                </CardContent>
                                <Box flexGrow={1} />
                                <CardActions sx={{ justifyContent: 'center' }}>
                                    {item.isDownload ? (
                                        <Link
                                            to={item.url}
                                            target="_blank"
                                            download
                                            style={{ textDecoration: 'none' }}
                                        >
                                            <Button
                                                component="div"
                                                color="primary"
                                                size="medium"
                                                variant="contained"
                                                startIcon={<Download />}
                                            >
                                                Download
                                            </Button>
                                        </Link>
                                    ) : (
                                        <Link
                                            to={item.url}
                                            style={{ textDecoration: 'none' }}
                                        >
                                            <Button>Learn more</Button>
                                        </Link>
                                    )}
                                </CardActions>
                            </Box>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default QuickAccess;
